<div class="preview-modal-section" *ngIf="emailHtmlContent; else noPreviewMode">
  <div class="desktop-view" *ngIf="activeMode === 'desktop'">
    <div class="masking-view">
      <div class="skeleton-loader">
        <div class="skeleton slim small"></div>
        <div class="skeleton slim large"></div>
      </div>
      <div class="skeleton-loader">
        <div class="skeleton slim small"></div>
        <div class="skeleton slim large"></div>
      </div>
      <div class="skeleton-loader">
        <div class="skeleton slim small"></div>
        <div class="skeleton slim large"></div>
      </div>
      <div class="skeleton-loader">
        <div class="skeleton slim small"></div>
        <div class="skeleton slim large"></div>
      </div>
      <div class="skeleton-loader">
        <div class="skeleton slim small"></div>
        <div class="skeleton slim large"></div>
      </div>
    </div>
    <div class="email-view">
      <h5 class="subject">
        {{ templateData.subject || "Maruti Suzuki Arena" }}
      </h5>
      <div class="d-flex gap-2 mt-3">
        <div class="sender-id">
          <div class="logo-image">
            <img src="assets/svg/common/suzuki-logo.svg" alt="logo" />
          </div>
          <span [pTooltip]="templateData.senderId ?? 'marutisuzuki@msil.com'">{{
            templateData.senderId ?? "marutisuzuki@msil.com"
          }}</span>
        </div>
        <span class="date-time">
          {{ currentTime | date : "shortTime" }}
        </span>
      </div>

      <iframe
        [srcdoc]="emailHtmlContent | linkify"
        class="mt-3 html-border"
        title="email-html-content"
      ></iframe>
    </div>
  </div>

  <div class="mobile-view" *ngIf="activeMode === 'mobile'">
    <div class="email-view">
      <div class="d-flex justify-content-between">
        <h5 class="subject">
          {{ templateData.subject || "Maruti Suzuki Arena" }}
        </h5>
        <span class="date-time">
          {{ currentTime | date : "shortTime" }}
        </span>
      </div>

      <div class="sender-id mt-3">
        <div class="logo-image">
          <img src="assets/svg/common/suzuki-logo.svg" alt="logo" />
        </div>
        <span [pTooltip]="templateData.senderId ?? 'marutisuzuki@msil.com'">{{
          templateData.senderId ?? "marutisuzuki@msil.com"
        }}</span>
      </div>

      <div [ngClass]="activeMode">
        <iframe
          [srcdoc]="emailHtmlContent | linkify"
          class="mt-3 html-border"
          title="email-html-content-active"
        ></iframe>
      </div>
    </div>
  </div>
</div>

<ng-template #noPreviewMode>
  <h4>Nothing To Preview</h4>
</ng-template>
